export const detectNumberFormat = () => {
  const formatter = new Intl.NumberFormat();
  const formatted = formatter.format(1000000.99);

  const commaCount = (formatted.match(/,/g) || []).length;
  const dotCount = (formatted.match(/\./g) || []).length;

  const isUSFormat = commaCount === 2 && dotCount === 1;

  return {
    decimalSeparator: isUSFormat ? "." : ",",
    thousandsSeparator: isUSFormat ? "," : ".",
  };
};
